import { DownOutlined, WarningOutlined } from '@ant-design/icons';
import { Select as AntdSelect, Avatar, TreeSelect } from 'antd';
import cx from 'classnames';
import { useField } from 'formik';
import { isNil } from "lodash";
import get from 'lodash/get';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../Input/Input.module.css';
import myStyles from './SelectForm.module.css';

const SelectForm = ({
  label = "",
  name = "",
  placeholder = "",
  size = "middle",
  className = "",
  mode = "",
  required = false,
  disabled = false,
  options = [],
  tagRender = null,
  suffixIcon = <DownOutlined />,
  onChange = () => { },
  onSearch = () => { },
  notFoundContent = null,
  tree = false,
  errors,
  touched
}) => {
  const { i18n } = useTranslation();
  const [field, meta, helpers] = useField(name);
  const { onBlur } = field;
  const { value } = meta;
  const { setValue } = helpers;
  const hasError = get(errors, name)
  // console.log("🚀 ~ hasError:", hasError)
  const buildTreeDataRecursive = (data, parentCode = null, seen = new Set()) => {
    return data
      .filter(item => (item.under ? item.under.id : null) === parentCode)
      .map(item => {
        if (seen.has(item.id)) {
          return null;
        }

        seen.add(item.id);

        const children = buildTreeDataRecursive(data, item.id, seen);

        return {
          title: i18n.language == 'th' ? item.name : item.nameEn,
          value: item.id,
          children: children.length > 0 ? children : undefined,
        };
      })
      .filter(item => item !== null);
  };

  const handleChange = (val, rest) => {
    setValue(val);
    onChange(val, rest);
  };

  const translatedError = i18n?.language === "th"
    ? `กรุณาเลือก ${label}`
    : `Please enter ${label?.toLowerCase?.()}`


  const processedOptions = useMemo(() => {
    return options.map(option => ({
      ...option,
      originalLabel: option.label, // Preserve the original label as a string
      label: (
        <div className={myStyles.option}>
          {option.imageData && (
            <Avatar style={{ marginRight: "5px" }} size={24} src={`data:image/png;base64,${option?.imageData}`} alt={option.label} />
          )}
          {option.icon && (
            <Avatar style={{ marginRight: "5px" }} size={24} src={option?.icon} alt={option.label} />
          )}
          {option.symbol && !option.icon && (
            <Avatar style={{ marginRight: '5px', backgroundColor: "#000000" }} size={24} gap={0}>
              {option.symbol}
            </Avatar>
          )}
          <span>{option.label}</span>
        </div>
      )
    }));
  }, [options]);

  const filterOption = (input, option) =>
    option.originalLabel.toLowerCase().includes(input.toLowerCase());

  return (
    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      {tree ? (
        <TreeSelect
          treeData={buildTreeDataRecursive(options)}
          placeholder={placeholder || label}
          onChange={handleChange}
          treeDefaultExpandAll
          allowClear
          className={myStyles.input}
          disabled={disabled}
          size={size}
        />
      ) : (
        <AntdSelect
          allowClear
          showSearch
          popupMatchSelectWidth={false}
          required={required}
          filterOption={filterOption}
          id={name}
          className={myStyles.input}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onSearch={onSearch}
          onBlur={onBlur}
          data-state={touched && hasError ? "error" : ""}
          status={touched && hasError ? "error" : ""}
          disabled={disabled}
          mode={mode}
          tagRender={tagRender}
          size={size}
          options={processedOptions}
          suffixIcon={suffixIcon}
        />
      )}

      {touched && hasError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {!isNil(hasError) ? hasError : translatedError}
        </span>
      )}
    </div>
  );
};

export default SelectForm;
